import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization`;

//  * FIND ORGANIZATION REPORT
export function findConsolidationExport(queryString) {
  return axios.get(`${URL}/consolidation`, {
    params: queryString
  });
}
// * UPDATE STATUS ORGANIZATION REPORT
export function exportConsolidation(queryString) {
  return axios({
    url: `${URL}/consolidation/export`,
    method: "GET",
    params: queryString,
    responseType: "blob"
  });
}
